import { render, staticRenderFns } from "./Geolocation.vue?vue&type=template&id=dd60520e&scoped=true&"
import script from "./Geolocation.vue?vue&type=script&lang=js&"
export * from "./Geolocation.vue?vue&type=script&lang=js&"
import style0 from "./Geolocation.vue?vue&type=style&index=0&id=dd60520e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd60520e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VDataTable})
